import React from 'react';

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap';
import styles from './styles.module.css';

const EmptyDashboard = ({ user, type }) => {

    return (
        <Container>
            <div className={styles['welcome']}>Welcome to BreatheEV</div>
        </Container>
    );

};

EmptyDashboard.propTypes = {
    user: PropTypes.string,
    type: PropTypes.string
}
const mapStateToProps = state => ({
    user: state.auth && state.auth.user ? state.auth.user.firstName : null,
    type: state.auth && state.auth.user ? state.auth.user.type : null
})
export default connect(mapStateToProps, {})(EmptyDashboard);